<template functional>
    <div>
        <div class="subscribe-starting">
            <img src="/static/image/starting-subscribe-spinner.png">
            <div class="starting-text-container">
                <div class="starting-number">{{ parent.getTimeBeforeFeedStart }}</div>
                <div class="starting-text">min</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {

    components: {

    },

    props: {
        parent: {
            type: Object,
            required: true,
        }
    },

    data (){
        return {
        };
    },

    computed: {
    },

    mounted (){
    },
    destroyed (){
    },
    methods: {
    },
};
</script>

<style lang="scss">
.subscribe-starting{
    position: relative;
    width: 50px;
    height: 50px;
    img{
        position: absolute;
        animation: rotating 2s linear infinite;
        width: 50px;
        height: 50px;
    }
    .starting-text-container{
        font-family: roboto-thin;
        text-transform: uppercase;
        color: #bbb;
        font-weight: bold;
        text-align: center;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        line-height: 16px;
        top: 9px;

    }
    .starting-number{
        font-size: 20px;
    }
    .starting-text-container{
        font-size: 9px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/page/Channels/configurationButton/starting-btn.vue